import React, { useState } from "react";
import { Link } from "react-router-dom";

const API_BASE = "https://api.mykcertifiedtranslations.com/api";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    fullName: "",
    emailAddress: "",
    subject: "",
    message: "",
  });

  const [statusMessage, setStatusMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      emailAddress: "",
      subject: "",
      message: "",
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsSending(true);
    setStatusMessage("");
    setIsError(false);

    try {
      const payload = new FormData();

      payload.append("fullName", formData.fullName);
      payload.append("emailAddress", formData.emailAddress);

      // Backend requires documentType, so we use it as contact subject.
      payload.append("documentType", formData.subject || "General Contact Message");

      payload.append("message", formData.message);

      const response = await fetch(`${API_BASE}/contact`, {
        method: "POST",
        body: payload,
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || data.success === false) {
        throw new Error(data.message || "Failed to send message.");
      }

      setIsError(false);
      setStatusMessage("Your message has been sent successfully.");
      resetForm();
    } catch (error) {
      setIsError(true);
      setStatusMessage(error.message || "Failed to send message.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <main className="section">
      <div className="container">
        <div className="contact-box">
          <div className="contact-text">
            <span className="section-label">Contact Us</span>

            <h2>Send us a message</h2>

            <p>
              Use this form for general questions, business enquiries, or help
              with your translation request.
            </p>

            <div className="contact-points">
              <div className="contact-point">✓ Fast response</div>
              <div className="contact-point">✓ Professional support</div>
              <div className="contact-point">✓ Clear communication</div>
            </div>

            <Link to="/" className="btn btn-secondary">
              Back to Website
            </Link>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="fullName">Full Name</label>
              <input
                id="fullName"
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-field">
              <label htmlFor="emailAddress">Email Address</label>
              <input
                id="emailAddress"
                type="email"
                name="emailAddress"
                placeholder="Email Address"
                value={formData.emailAddress}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-field">
              <label htmlFor="subject">Subject</label>
              <input
                id="subject"
                type="text"
                name="subject"
                placeholder="How can we help?"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Write your message here"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={isSending}>
              {isSending ? "Sending..." : "Send Message"}
            </button>

            {statusMessage && (
              <p className={`form-status ${isError ? "error-message" : "success-message"}`}>
                {statusMessage}
              </p>
            )}
          </form>
        </div>
      </div>
    </main>
  );
}